import { CardProps } from './card.interface';
import * as S from './card.styles';

const Card = ({ children, space = 'lg', boxShadow = 'hight', style, className }: CardProps) => {
  return (
    <S.WrapperCard $boxShadow={boxShadow} $spacing={space} style={style} className={className}>
      {children}
    </S.WrapperCard>
  );
};

export default Card;
